import { useGlobalContext } from '../context'

function WaitingScreen() {
    const { players, index, nextPlayer} = useGlobalContext();
    
    return (
        <div className='container border skip'>
            <h3 className='m-3 mb-5'>Next Player: {players[index + 1].name}</h3>
            <img src="./img/devil.png" alt=""/>
            <button  className='btn btn-dark next' onClick={() => nextPlayer(index)}>next player</button>
        </div>
    )
}

export default WaitingScreen;